import React, { useEffect } from 'react';
import { Formik, Form, Field, useFormikContext } from 'formik';
import { FormControl, FormLabel, Input, Checkbox, Button, Select } from '@chakra-ui/react';

// FormFields Component
const FormFields = ({ fields, editData }) => {
  
  const { setValues, setFieldValue, values } = useFormikContext();
  console.log(useFormikContext())
  useEffect(() => {
    if (editData) {
      setValues(editData);
    }
  }, [editData, setValues]);

  return (
    <>
      {fields.map(({ label, name, type }) => (
        <FormControl key={name} mb={4}>
          <FormLabel>{label}</FormLabel>
          {type === 'checkbox' ? (
            <Checkbox
              name={name}
              isChecked={values[name] || false}
              onChange={(e) => setFieldValue(name, e.target.checked)}
            />
          ) : (
            <Input
              name={name}
              type={type}
              value={values[name] || ''}
              onChange={(e) => setFieldValue(name, e.target.value)}
            />
          )}
        </FormControl>
      ))}
    </>
  );
};

// Generic Form Component
const GenericForm = ({ initialValues, editData, setModalData, fields }) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => {
      setModalData(values);
      console.log('Submitted Data:', values);
    }}
  >
    {() => (
      <Form>
        <FormFields fields={fields} editData={editData} />
        <Button type="submit" colorScheme="blue" mt={4}>Submit</Button>
      </Form>
    )}
  </Formik>
);




export const Kaleyra = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
    
      <FormControl>
        <FormLabel>Name</FormLabel>
        <Input name="name" value={values?.name} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>API Key</FormLabel>
        <Input name="apiKey" value={values?.apiKey} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Sender ID</FormLabel>
        <Input name="senderId" value={values?.senderId} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Gateway Type</FormLabel>
        <Select name="gatewayType" value={values?.gatewayType} onChange={handleChange}>
          <option value="transactional">Transactional</option>
          <option value="promotional">Promotional</option>
        </Select>
      </FormControl>
    </>
  );
};


export const Telnyx = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
      <FormControl>
        <FormLabel>Username</FormLabel>
        <Input name="userName" value={values?.userName} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Profile ID</FormLabel>
        <Input name="profileid" value={values?.profileid} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Password</FormLabel>
        <Input name="password" value={values?.password} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Phone</FormLabel>
        <Input name="phone" value={values?.phone} onChange={handleChange} />
      </FormControl>
    </>
  );
};

export const Sinch = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
    <FormControl>
        <FormLabel>Name</FormLabel>
        <Input name="name" value={values?.name} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>App ID</FormLabel>
        <Input name="appid" value={values?.appid} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Password</FormLabel>
        <Input name="pass" type="password" value={values?.pass} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Sender ID</FormLabel>
        <Input name="senderId" value={values?.senderId} onChange={handleChange} />
      </FormControl>
    </>
  );
};
export const TrustSignal = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
      <FormControl>
        <FormLabel>API Key</FormLabel>
        <Input name="apiKey" value={values?.apiKey} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Sender ID</FormLabel>
        <Input name="senderId" value={values?.senderId} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Gateway Type</FormLabel>
        <Select name="gatewayType" value={values?.gatewayType} onChange={handleChange}>
          <option value="transactional">Transactional</option>
          <option value="promotional">Promotional</option>
        </Select>
      </FormControl>
    </>
  );
};

export const Equitas = () => {
  const { values, handleChange, setFieldValue } = useFormikContext();

  return (
    <>
      <FormControl>
        <FormLabel>Channel ID</FormLabel>
        <Input name="channelID" value={values?.channelID} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Transaction Type</FormLabel>
        <Input name="transactionType" value={values?.transactionType} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Transaction Sub Type</FormLabel>
        <Input name="transactionSubType" value={values?.transactionSubType} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Conversation ID</FormLabel>
        <Input name="conversationID" value={values?.conversationID} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>External Reference ID</FormLabel>
        <Input name="externalReferenceId" value={values?.externalReferenceId} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Is Async</FormLabel>
        <Checkbox
          name="isAsync"
          isChecked={values?.isAsync}
          onChange={(e) => setFieldValue('isAsync', e.target.checked)}
        />
      </FormControl>
    </>
  );
};


export const RouteMobile = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
      <FormControl>
        <FormLabel>Username</FormLabel>
        <Input name="userName" value={values?.userName} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Password</FormLabel>
        <Input name="password" type="password" value={values?.password} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Sender ID</FormLabel>
        <Input name="senderId" value={values?.senderId} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Gateway Type</FormLabel>
        <Select name="gatewayType" value={values?.gatewayType} onChange={handleChange}>
          <option value="transactional">Transactional</option>
          <option value="promotional">Promotional</option>
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>DLT Entity ID</FormLabel>
        <Input name="dltEntityId" value={values?.dltEntityId} onChange={handleChange} />
      </FormControl>
    </>
  );
};

export const SBI = () => {
  const { values, handleChange } = useFormikContext();

  return (
    <>
      <FormControl>
        <FormLabel>URL</FormLabel>
        <Input name="url" value={values?.url} onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Sender ID</FormLabel>
        <Input name="senderId" value={values?.senderId} onChange={handleChange} />
      </FormControl>
      
    </>
  );
};
